module.exports = __webpack_public_path__ + "static/media/logo_SacomBank.42b8083e.svg";